import { PhoneCall } from "lucide-react";

export const MobileMenu = ({ links, onGo }) => (
    <div data-testid="nav-mobile-menu" className="lg:hidden bg-[#F4F1EA] h-[calc(100vh-76px)] flex flex-col px-6 pt-6 pb-10 overflow-y-auto">
        <div className="flex-1">
            {links.map((l, i) => (
                <button
                    key={l.href}
                    data-testid={`${l.testid}-mobile`}
                    onClick={() => onGo(l.href)}
                    style={{ animationDelay: `${i * 70}ms` }}
                    className="mobile-nav-item flex w-full items-baseline justify-between text-left font-serif font-light text-3xl text-[#2B2825] py-5 border-b border-[#DDD6C8]"
                >
                    {l.label}
                    <span className="font-sans text-[10px] tracking-[0.25em] text-[#8C8275]">0{i + 1}</span>
                </button>
            ))}
        </div>
        <div className="mt-8 space-y-5">
            <button
                data-testid="nav-btn-cta-kennenlernen-mobile"
                onClick={() => onGo("#kontakt")}
                className="w-full bg-[#2B2825] text-[#FAF8F5] font-sans text-[12px] font-medium tracking-[0.15em] uppercase px-5 py-4"
            >
                Kennenlerngespräch anfragen
            </button>
            <a data-testid="nav-btn-krisenhotline" href="tel:147" className="flex items-center justify-center gap-2 text-sm text-[#59534C]">
                <PhoneCall size={15} /> Akute Krise? Pro Juventute: 147
            </a>
        </div>
    </div>
);
